'use client';

import { FC, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

import { Icon, Link, MegaMenuCustom, useData } from '@/components';

import style from './nav.module.scss';
import classNames from 'classnames';

const Nav: FC = () => {
  const { navigation } = useData();
  const pathname = usePathname();
  const navbarRef = useRef<HTMLElement | null>(null);

  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  return (
    <nav aria-label="Main navigation" className={style.navbar} ref={navbarRef}>
      <ul className={style.navbar_list} key={pathname}>
        {navigation.data?.links?.map((item: any, index: number) => {
          const { type, uid } = item.external_link;
          const isExpandable = ['custom_mega_menu', 'mega_nav'].includes(type);
          const isExpanded = expandedIndex === index;

          if (isExpandable) {
            return (
              <li
                aria-controls={`megamenu-${index}`}
                aria-expanded={isExpanded}
                aria-haspopup="true"
                aria-label={`Expand menu ${item?.label}`}
                className={style.navbar_list__item}
                key={index}
                onBlur={e => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setExpandedIndex(null);
                  }
                }}
                onFocus={() => setExpandedIndex(index)}
                onMouseEnter={() => setExpandedIndex(index)}
                onMouseLeave={() => setExpandedIndex(null)}
                role="button"
                tabIndex={0}
              >
                <h4>{item?.label}</h4>
                <Icon aria-hidden="true" name="angle-up" />
                {!!uid && (
                  <MegaMenuCustom
                    className={classNames(style.navbar_menu, {
                      [style.navbar_menu__hidden]: !isExpanded,
                    })}
                    id={`megamenu-${index}`}
                    itemID={uid}
                    navbarRef={navbarRef}
                  />
                )}
              </li>
            );
          }

          return (
            <li className={style.navbar_list__item} key={index}>
              <Link aria-label={`Go to ${item?.label}`} href={item?.link}>
                {item?.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
